<div class="mct-flex-lt-md mct-col-lt-md mct-flex-gt-md mct-row-gt-md mct-gap-6" *ngIf="searchParams"   >
  <div class="mct-flex mct-col mct-basis-28"  >
    <label>{{ 'web-content.search-params.title' | translate | titlecase }}</label>
    <input
      type="text"
      placeholder="{{ 'web-content.search-params.title' | translate | titlecase }}"
      [(ngModel)]="searchParams.ContentTitle"
      data-cy="inputWebContentSearchTitle"
    />
  </div>
  <div class="mct-flex mct-col mct-basis-28"  >
    <label>{{ 'web-content.search-params.format' | translate | titlecase }}</label>
    <p-select
      placeholder="{{ 'web-content.search-params.select-label' | translate }}"
      [(ngModel)]="searchParams.ContentFormat"
      [options]="webContentFormats"
      [style]="{ width: '100%', height: '36px' }"
      showClear
      appendTo="body"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-basis-28"  >
    <label>{{ 'web-content.search-params.content-type' | translate | titlecase }}</label>
    <p-select
      placeholder="{{ 'web-content.search-params.select-label' | translate }}"
      [(ngModel)]="searchParams.ContentTypeId"
      [options]="webContentTypes"
      [style]="{ width: '100%', height: '36px' }"
      showClear
      appendTo="body"
      optionLabel="ContentType"
      optionValue="ContentTypeID"
    ></p-select>
  </div>
  <div class="mct-flex mct-col mct-flex-1-1-0"  >
    <label>{{ 'web-content.search-params.content-id' | translate | titlecase }}</label>
    <input
      type="number"
      placeholder="{{ 'web-content.search-params.content-id' | translate | titlecase }}"
      [(ngModel)]="searchParams.ContentId"
      data-cy="inputWebContentSearchContentId"
    />
  </div>
</div>
